import React, { Component } from 'react';
import HeaderView from './HeaderView';

export default class Header extends Component {
  go(dest) {
    if (!dest) {
      throw new Error('cannot go nowhere');
    }
    if (!this.props.history) {
      throw new Error('cannot go without history');
    }
    this.props.history.push(dest);
  }

  get goHome() {
    const history = this.props.history;
    return () => {
      history.push('/');
    };
  }

  render() {
    const props = { ...this.props };
    const { toggleSidebar } = this.props;
    delete props.children;

    return (
      <HeaderView
        gatekeeper={this.context ? this.context.gatekeeper : null}
        {...props}
        goHome={this.goHome}
        login={props.userAuthorize}
        logout={props.userLogout}
        toggleSidebar={toggleSidebar}
      />
    );
  }
}
